<!--
* @Author : ShaJiaJing
* @Date :  2019/6/17
* @Version : 1.0
* @Content : 机器人购买页
-->
<template>
  <div class="purchase">
    <a-steps class="steps" :current="currentStep" :status="status">
      <a-step v-for="item in 2" :key="item" :title="$t(`private.purchase.steps.title${item}`)" />
      <a-step :key="3" :title="$t(`private.purchase.steps.title3[${payRes}]`)">
        <a-icon type="loading" v-if="payRes === 3" slot="icon"/>
      </a-step>
      <!--<a-step title="订单确认" />-->
      <!--<a-step title="选择支付方式" />-->
      <!--<a-step title="选择支付成功" />-->
    </a-steps>
    <!--第一步：订单填写-->
    <div class="write-step" v-if="currentStep === 0">
      <r-pointer :textName="$t('private.purchase.step1.title')">
        <div slot="btn">
          <a-button type="primary" style="margin-right: 24px" @click="showRenewModal">
            {{ $t('private.purchase.step1.addRenew') }}
          </a-button>
          <!-- 新增一个机器人 -->
          <a-button type="primary" @click="addRobot">
            {{ $t('private.purchase.step1.addRobot') }}
          </a-button>
        </div>
      </r-pointer>
      <a-table
        :columns="columns"
        :dataSource="list"
        :rowSelection="rowSelection"
        :pagination="false"
        rowKey="key"
        class="list">
        <template slot="cover" slot-scope="model">
          <img class="cover" src="@assets/images/designer.png" v-if="model === 1">
          <img class="cover" src="@assets/images/robot.png" v-else>
        </template>
        <div class="license" slot="license" slot-scope="license">
          <a-tooltip placement="bottomLeft" :title="license.no">
            <p class="no ellipsis" v-text="license.no"></p>
          </a-tooltip>
          <a-tooltip placement="bottomLeft" :title="license.alias">
            <p class="alias ellipsis" v-text="license.alias"></p>
          </a-tooltip>
          <a-tooltip placement="bottomLeft" :title="license.expireDate">
            <p class="expire-date ellipsis" v-text="license.expireDate"></p>
          </a-tooltip>
        </div>
        <div class="bind" slot="bind" slot-scope="bind">
          <a-tooltip placement="bottomLeft" :title="bind.name">
            <p class="name ellipsis" v-text="bind.name"></p>
          </a-tooltip>
          <a-tooltip placement="bottomLeft" :title="bind.ip">
            <p class="ip ellipsis" v-text="bind.ip"></p>
          </a-tooltip>
          <a-tooltip placement="bottomLeft" :title="bind.dcode">
            <p class="dcode ellipsis" v-text="bind.dcode"></p>
          </a-tooltip>
        </div>
        <div class="count" slot="count" slot-scope="record">
          <span v-if="record.id >= 0" v-text="record.count"></span>
          <a-input-number
            style="width: 100%;"
            :min="1"
            :max="100"
            v-model="record.count"
            @blur="() => {if (!record.count) record.count = 1 }"
            v-else />
        </div>
        <div class="order-month" slot="orderMonth" slot-scope="record">
          <a-select v-model="record.orderMonth" @change="changeMonth(record, getMonthOptions(record.type))">
            <a-select-option v-for="item in getMonthOptions(record.type)" :key="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </div>
        <span class="price" slot="price" slot-scope="origPrice, record">
          ￥{{ moneyComma(origPrice * record.count) }}
        </span>
        <div class="operation" slot="operation" slot-scope="text, record">
          <span @click="delListItem([record.key])">
            {{ $tc('private.actions.delete', 1) }}
          </span>
        </div>
        <div class="all-actions" slot="footer" slot-scope="text">
          <span v-if="text"></span>
          <a-button :disabled="!selectedRowKeys.length" type="primary" @click="delListItem(selectedRowKeys)">
            {{ $tc('private.actions.delete', 1) }}
          </a-button>
        </div>
      </a-table>
      <div class="operations recommendation">
        <!-- 合作码 -->
        <div class="rec-code">
          <div v-show="useProCodeFailed" class="apc-box">
            <a-checkbox :checked="apcChecked" @change="onApcChange">{{ $t('private.purchase.step1.popUps[5]') }}</a-checkbox>
            <!-- 错误推荐码提示语 -->
            <div v-show="apcInfo.showErrTip" class="apc-err-tip">{{ $t('private.purchase.step1.proCodeErrTips') }}</div>
            <div class="apc-con clearfix" v-show="apcInfo.showProCodeInput">
              <a-input
                class="fl"
                :value="apcInfo.proCode"
                @change="proCodeChange"
                :disabled="apcInfo.showPrice"></a-input>
              <a-button class="fl" @click="useProCode()" :disabled="apcInfo.showPrice">{{ $t('private.purchase.step1.popUps[6]') }}</a-button>
            </div>
          </div>
        </div>
        <!-- 市场价 -->
        <!--<p class="discount">{{ $t('private.purchase.info.marketPrice') }}￥{{ moneyComma(shoppingCart.origPrice) }}</p>-->
        <!-- 应付款 -->
        <p class="payable">{{ $t('private.purchase.info.payable') }}<strong>￥{{ moneyComma(shoppingCart.dctPrice) }}</strong></p>
        <p class="protocol">
          <a-checkbox :checked="agree" @change="(e) => agree = e.target.checked">
            {{ $t('private.purchase.info.agree') }}
          </a-checkbox>
          <a @click="readMe">{{ $t('private.purchase.info.protocol') }}</a>
        </p>
        <a-button type="primary" size="large" :disabled="!(selectedRowKeys.length && agree)" @click="nextStep">
          {{ $t('private.purchase.step1.next') }}
        </a-button>
      </div>

      <a-modal
        :title="$t('private.purchase.step1.addRenewTitle')"
        :width="780"
        v-model="renewModal"
        :destroyOnClose="true"
        wrapClassName="my-modal"
        @ok="addRenew(selectedRenewKeys)">
        <!--<a-form layout="inline">
          <a-form-item label="视图名称">
            <a-input />
          </a-form-item>
        </a-form>-->
        <a-table
          :columns="addColumns"
          :dataSource="renewList"
          :rowSelection="renewSelection"
          :pagination="false"
          rowKey="key"
          class="list"
        >
          <div class="license" slot="license" slot-scope="license">
            <p class="no" v-text="license.no"></p>
            <a-tooltip placement="bottomLeft" :title="license.alias">
              <p class="alias ellipsis" v-text="license.alias"></p>
            </a-tooltip>
            <p class="expire-date" v-text="license.expireDate"></p>
          </div>
          <div class="bind" slot="bind" slot-scope="bind">
            <p class="name" v-text="bind.name"></p>
            <p class="ip" v-text="bind.ip"></p>
            <p class="dcode" v-text="bind.dcode"></p>
          </div>
        </a-table>
      </a-modal>
    </div>
    <!-- 第二步：订单确认 -->
    <div class="order-step" v-else-if="currentStep === 1">
      <a-table
        :columns="orderColumns"
        :dataSource="orderList"
        :pagination="false"
        rowKey="key"
        class="list"
      >
        <div class="info" slot="info" slot-scope="info, record">
          <strong v-if="record.model === 1">Studio{{ $t('private.purchase.step2.sub') }}</strong>
          <strong v-else>Robot {{ $t('private.purchase.step2.sub') }}</strong>
          <p>
            {{ `${$t('private.purchase.step2.deadline')} ${moment().format('YYYY-MM-DD')}~${record.expireDate}` }}
          </p>
          <p>
            {{ `${$t('private.purchase.step2.type')} ${record.id >= 0 ? $tc('private.purchase.step2.typeValue', 1) : $tc('private.purchase.step2.typeValue', 2)}` }}
          </p>
          <p>{{ $t('private.purchase.step2.name') }} {{ info.alias }}</p>
        </div>
        <span slot="origPrice" slot-scope="origPrice, record">
          ￥{{ moneyComma(origPrice * record.count) }}
        </span>
        <span slot="dctPrice" slot-scope="dctPrice, record">
          ￥{{ moneyComma(dctPrice * record.count) }}
        </span>
      </a-table>
      <div class="payment-method">
        <h3>{{ $t('private.purchase.step2.paymentMethod') }}</h3>
        <a-radio-group class="methods" v-model="paymentMethod" @change="jumpProduct" name="paychoose">
          <!-- 支付宝 -->
          <a-radio v-if="false" :value="0">
            <img src="~@assets/images/purchase/zfb.png" alt="">
          </a-radio>
          <!-- 微信支付不支持>4000元的支付，暂时注释掉 -->
          <!-- <a-radio :value="1">
            <img src="~@assets/images/purchase/wx.png" alt="">
          </a-radio> -->
          <!-- paypal -->
          <a-radio v-if="false" :value="2">
            <img src="~@assets/images/purchase/paypal.png" alt="">
          </a-radio>
          <!-- 兑换卡支付 -->
          <a-radio :value="3" :disabled="!(orderList.length === 1 && orderList[0].count === 1)">
            <a-tooltip placement="top" :title="!(orderList.length === 1 && orderList[0].count === 1) ? $t('private.purchase.card') : ''">
              <img src="~@assets/images/purchase/card.png" >
            </a-tooltip>
          </a-radio>
        </a-radio-group>
      </div>
      <div class="operations">
        <!--<p class="discount">{{ $t('private.purchase.info.marketPrice') }}￥{{ moneyComma(shoppingCart.origPrice) }}</p>-->
        <p class="payable">{{ $t('private.purchase.info.payable') }}<strong>￥{{ moneyComma(shoppingCart.dctPrice) }}</strong></p>
        <p class="invoice">{{ $t('private.purchase.info.invoice') }}</p>
        <p class="license">{{ $t('private.purchase.info.license') }}</p>
        <p class="protocol">
          <a-checkbox :checked="agree" @change="(e) => agree = e.target.checked">
            {{ $t('private.purchase.info.agree') }}
          </a-checkbox>
          <a @click="readMe">{{ $t('private.purchase.info.protocol') }}</a>
        </p>
        <a-button :disabled="!agree" type="primary" size="large" @click="nextStep">
          {{ $t('private.purchase.step2.next') }}
        </a-button>
      </div>
    </div>
    <!-- 第三步：支付成功 -->
    <div class="finish-step" v-else>
      <template v-if="payRes !== 3">
        <template v-if="status === 'error'">
          <b-icon type="iconrenwushibai"></b-icon>
          <p class="pay-ok" v-text="$t(`private.purchase.step4.payment[${payRes}]`)"></p>
        </template>
        <template v-else>
          <b-icon type="iconwanchengrenwu"></b-icon>
          <p class="pay-ok" v-text="$t(`private.purchase.step4.payment[${payRes}]`)"></p>
          <p class="pay-info" v-text="$t('private.purchase.step4.welcome')"></p>
          <p class="operations">
<!--            <a-button type="primary" size="large" style="margin-right: 24px" @click="$router.push('/private/order')">-->
<!--              {{ $t('private.purchase.step4.details') }}-->
<!--            </a-button>-->
            <a-button type="primary" size="large" @click="$router.push('/robot&studio/list')">
              {{ $t('private.purchase.step4.instance') }}
            </a-button>
          </p>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { moneyComma } from '@/utils/util'
import { getProductList, getPriceList, payOrder, getPOrderStatus, getProCodeDisc } from '@api/purchase'
import moment from 'moment'
import { mapGetters } from 'vuex'
function getOptions (arr) {
  return arr.map(row => {
    return {
      label: window.$globalHub.$t('private.purchase.step1.month', { n: row.servMonth }),
      value: row.servMonth,
      sellPrice: row.sellPrice, // 售价
      marketPrice: row.marketPrice // 市场价
    }
  })
}

export default {
  components: {},
  data () {
    return {
      useProCodeFailed: true, // 是否正确使用推荐码
      apcChecked: false, // 是否选中输入推荐码
      apcInfo: {
        showProCodeInput: false, // 显示推荐码输入框
        proCode: '', // 推荐码
        showPrice: false, // 显示推广价
        price: 0, // 推广价
        showErrTip: false // 错误推荐码的提示语
      },
      moment,
      currentStep: 0, // 0：订单填写，1：订单确认，2：支付结果
      agree: true,
      list: [],
      agentNewOptions: [],
      agentRenewOptions: [],
      studioNewOptions: [],
      studioRenewOptions: [],
      columns: [
        {
          title: '',
          dataIndex: 'model',
          width: 88,
          scopedSlots: { customRender: 'cover' }
        },
        {
          title: this.$tc('private.purchase.steps.license', 1),
          key: 'license',
          dataIndex: 'license',
          customHeaderCell: () => {
            return {
              style: {
                minWidth: '100px',
                maxWidth: '120px'
              }
            }
          },
          customCell: (record, index) => {
            return {
              style: {
                minWidth: '100px',
                maxWidth: '150px'
              }
            }
          },
          scopedSlots: { customRender: 'license' }
        },
        {
          title: this.$t('private.purchase.steps.bind'),
          dataIndex: 'bind',
          customHeaderCell: () => {
            return {
              style: {
                minWidth: '150px'
              }
            }
          },
          customCell: (record, index) => {
            return {
              style: {
                minWidth: '150px',
                maxWidth: '150px'
              }
            }
          },
          scopedSlots: { customRender: 'bind' }
        },
        {
          title: this.$t('private.purchase.steps.count'),
          // dataIndex: 'count',
          key: 'count',
          customHeaderCell: () => {
            return {
              style: {
                minWidth: '90px',
                maxWidth: '120px'
              }
            }
          },
          customCell: (record, index) => {
            return {
              attrs: {
              },
              style: {
                minWidth: '90px',
                maxWidth: '120px',
                width: '120px'
              }
            }
          },
          scopedSlots: { customRender: 'count' }
        },
        {
          title: this.$t('private.purchase.steps.purchaseTime'),
          key: 'orderMonth',
          width: 150,
          scopedSlots: { customRender: 'orderMonth' }
        },
        {
          title: this.$t('private.common.expireDate'),
          dataIndex: 'expireDate',
          width: 150,
          customHeaderCell: () => {
            return {
              style: {
                minWidth: '110px'
              }
            }
          },
          customCell: (record, index) => {
            return {
              attrs: {
              },
              style: {
                color: '#666',
                minWidth: '110px'
              }
            }
          }
        },
        {
          title: this.$t('private.purchase.steps.origPrice'),
          dataIndex: 'origPrice',
          width: 150,
          scopedSlots: { customRender: 'price' }
        },
        {
          title: this.$t('operation.tableOperation'),
          key: 'operation',
          customHeaderCell: () => {
            return {
              style: {
                minWidth: '60px'
              }
            }
          },
          scopedSlots: { customRender: 'operation' }
        }
      ],
      selectedRowKeys: [],
      renewModal: false,
      renewList: [],
      addColumns: [
        {
          title: this.$tc('private.purchase.steps.license', 1),
          key: 'license',
          dataIndex: 'license',
          scopedSlots: { customRender: 'license' }
        },
        {
          title: this.$t('private.purchase.steps.bind'),
          dataIndex: 'bind',
          width: 180,
          scopedSlots: { customRender: 'bind' }
        }
      ],
      selectedRenewKeys: [],
      // 确认支付
      orderColumns: [
        {
          title: this.$tc('private.purchase.steps.license', 2),
          dataIndex: 'license',
          scopedSlots: { customRender: 'info' }
        },
        {
          title: this.$t('private.purchase.steps.count'),
          dataIndex: 'count'
        },
        {
          title: this.$t('private.purchase.steps.origPrice'),
          dataIndex: 'origPrice',
          scopedSlots: { customRender: 'origPrice' }
        },
        {
          title: this.$t('private.purchase.steps.dctPrice'),
          dataIndex: 'dctPrice',
          scopedSlots: { customRender: 'dctPrice' }
        }
      ],
      undiscountedPrice: 0, // 未打折的售价
      orderList: [],
      paymentMethod: 0,
      wx: null,
      status: 'process',
      payRes: 0 // 0: 支付成功，1：支付失败，2：取消订单，3：支付中
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 订单填写的表格选中数据
    rowSelection () {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: (keys) => {
          this.$set(this, 'selectedRowKeys', keys)
        }
      }
    },
    renewSelection () {
      const { selectedRenewKeys } = this
      return {
        selectedRenewKeys,
        onChange: (keys) => {
          this.$set(this, 'selectedRenewKeys', keys)
        }
      }
    },
    shoppingCart () {
      const { selectedRowKeys } = this
      if (selectedRowKeys.length) {
        const list = this.list.filter(row => selectedRowKeys.indexOf(row.key) >= 0)
        const subject = list.some(row => row.model === 2) && list.some(row => row.model === 1) ? 'Robot,Studio' : (list.some(row => row.model === 2) ? 'Robot' : 'Studio')
        const origPrice = list.map(row => row.origPrice * row.count)
        const dctPrice = list.map(row => row.dctPrice * row.count)
        const finalDctPrice = dctPrice.length && dctPrice.reduce((pre, next) => pre + next).toFixed(2)
        // console.log('-------购物车选择的价格数据：', finalDctPrice)
        // 保存原始价格
        this.setUndiscountedPrice(finalDctPrice)
        return {
          origPrice: origPrice.length && origPrice.reduce((pre, next) => pre + next), // 原价
          dctPrice: finalDctPrice, // 售价
          // dctPrice: 0.1, // 测试
          body: subject,
          subject,
          custNo: JSON.parse(this.$store.getters.userInfo).custNo
        }
      }
      // 保存原始价格
      this.setUndiscountedPrice()
      return {
        origPrice: 0, // 原价
        dctPrice: 0, // 售价
        body: '',
        subject: '',
        custNo: JSON.parse(this.$store.getters.userInfo).custNo
      }
    }
  },
  async created () {
    const { step = 0, type = '', cancel = false, paymentId = '', PayerID: payerId = '' } = this.$route.query
    this.currentStep = Number(step)
    if (cancel) {
      this.status = 'error'
      this.payRes = 2
    } else if (Number(type) === 3 && this.currentStep === 2) {
      this.payRes = 3
      const res = await getPOrderStatus({ paymentId, payerId })
      this.status = res.state ? 'finish' : 'error'
      this.payRes = res.state ? 0 : 1
    }
    this.getProductList()
  },
  mounted () {
  },
  methods: {
    moneyComma,
    // 设置未打折的售价
    setUndiscountedPrice (price = 0) {
      this.undiscountedPrice = price
      // console.log('----------未打折的售价：', this.undiscountedPrice)
    },
    readMe () {
      window.open('https://restapi.i-search.com.cn/file/用户软件许可协议.html', '用户软件许可协议', 'width=800,height=600,location=no,menubar,left=300')
    },
    // 前往订单确认
    nextStep () {
      switch (this.currentStep) {
        case 0:
          const { selectedRowKeys } = this
          this.orderList = this.list.filter(row => selectedRowKeys.indexOf(row.key) >= 0)
          this.currentStep++
          break
        case 1:
          if (this.paymentMethod === 3) {
            this.$router.push(`/pay/card?de=${JSON.stringify(this.orderList[0])}`)
            return
          }
          this.payOrder()
          // this.$router.push('/pay/wx?no=1')
          break
        case 2:
          break
      }
      // this.currentStep++
    },
    async payOrder () {
      const userInfo = JSON.parse(this.userInfo)
      const orderList = this.orderList.map(row => {
        return {
          id: row.id,
          model: row.model,
          origPrice: row.origPrice,
          dctPrice: row.dctPrice,
          orderMonth: row.orderMonth,
          instanceNo: row.instanceNo,
          count: row.count
        }
      })
      const params = {
        // orderList,
        orderList: JSON.stringify(orderList),
        ...this.shoppingCart
      }
      // 测试使用
      if (userInfo.username === '16639633686') {
        params.dctPrice = 0.01
      }
      const type = this.paymentMethod
      const res = await payOrder(type, params)
      if (type === 0) {
        const div = document.createElement('div')
        div.innerHTML = res
        document.body.appendChild(div)
        document.forms[0].submit()
      } else if (type === 1) {
        this.$router.push({ path: '/pay/wx', query: { no: res.result.outTradeNo, qrcode: res.result.codeUrl } })
      } else {
        const { href } = res.result
        window.location.href = href
      }
    },
    showRenewModal () {
      this.renewModal = true
      this.getRenewalList()
    },
    addRenew (keys) {
      const list = this.renewList.filter(row => keys.indexOf(row.key) >= 0)
      this.list.push(...list)
      list.map(row => {
        this.selectedRowKeys.push(row.key)
      })
      this.renewModal = false
    },
    addRobot () {
      const newIndex = this.list.findIndex(row => row.type === 4)
      if (newIndex >= 0) {
        this.list[newIndex].count++
      } else {
        const key = this.list.length
        const agentNewOption = this.agentNewOptions[0]
        this.list.push({
          key,
          id: -1,
          model: 2,
          dctPrice: agentNewOption.sellPrice,
          origPrice: agentNewOption.marketPrice,
          orderMonth: agentNewOption.value,
          expireDate: this.getExpireDate('', agentNewOption.value),
          count: 1,
          instanceNo: '',
          type: 4,
          license: {
            no: '',
            alias: 'Robot',
            expireDate: ''
          },
          bind: {
            name: this.$t('private.purchase.step1.bind'),
            ip: '',
            dcode: ''
          }
        })
        this.selectedRowKeys.push(key)
      }
    },
    delListItem (indexs) {
      indexs.map(key => {
        this.list = this.list.filter(row => row.key !== key)
        this.selectedRowKeys = this.selectedRowKeys.filter(row => row !== key)
      })
    },
    // 更改购买时间
    changeMonth (record, options) {
      const monthInfo = options.find(row => row.value === record.orderMonth)
      const expireDate = this.getExpireDate(record.license.expireDate, record.orderMonth)
      Object.assign(record, {
        expireDate,
        origPrice: monthInfo.marketPrice,
        dctPrice: monthInfo.sellPrice
      })
    },
    // 获取选中购买时间对应的options
    getMonthOptions (type) {
      switch (type) {
        case 1:
          return this.studioRenewOptions
        case 2:
          return this.agentRenewOptions
        case 3:
          return this.studioNewOptions
        case 4:
          return this.agentNewOptions
      }
    },
    getExpireDate (oldDate, month) {
      if (moment().isAfter(oldDate) || !oldDate) {
        // 已过期
        return moment().add(month, 'M').format('YYYY-MM-DD')
      } else {
        // 未过期
        return moment(oldDate).add(month, 'M').format('YYYY-MM-DD')
      }
    },
    async getProductList () {
      const { agentIds = '', studioId = '' } = this.$route.query
      await this.getPriceList()
      if (!(agentIds || studioId)) {
        this.addRobot()
        return
      }
      const params = {
        agentIds,
        filterIds: '',
        studioId,
        filterStudioId: ''
      }
      const list = await this.getList(params)
      this.list = list.map((row, index) => {
        row.key = index
        this.selectedRowKeys.push(index)
        return row
      })
    },
    async getRenewalList () {
      const filterStudioId = []
      const filterIds = []
      this.list.map(row => {
        if (row.type === 1) {
          filterStudioId.push(row.id)
        } else if (row.type === 2) {
          filterIds.push(row.id)
        } else {}
      })
      const params = {
        agentIds: '',
        filterIds: filterIds.join(),
        studioId: '',
        filterStudioId: filterStudioId.join()
      }
      const list = await this.getList(params)
      this.renewList = list.map((row, index) => {
        row.key = 'r' + index
        return row
      })
    },
    getList (params) {
      const studioRenewOption = this.studioRenewOptions[0]
      const agentRenewOption = this.agentRenewOptions[0]
      return getProductList(params).then(({ agent, studio }) => {
        /**
         * id: 设计器/机器人id
         * model: 购买/续费类型，1-设计器；2-机器人
         * dctPrice：折扣价
         * origPrice：原价/市场价
         * orderMonth：续费月份
         * license: 许可信息
         * bind: 当前绑定用户
         * count: 数量
         * instanceNo: 实例号
         * expireDate: 到期时间
         * type: 类型，1-续费设计器；2-续费机器人；3-新增设计器；4-新增机器人
         */
        const studioArr = []
        if (studio) {
          studioArr.push({
            id: studio.id,
            model: 1,
            dctPrice: studioRenewOption.sellPrice,
            origPrice: studioRenewOption.marketPrice,
            orderMonth: studioRenewOption.value,
            expireDate: this.getExpireDate(studio.expireDate, studioRenewOption.value),
            count: 1,
            instanceNo: studio.stuNo,
            type: 1,
            license: {
              no: studio.stuNo,
              alias: studio.stuAlias,
              expireDate: studio.expireDate
            },
            bind: {
              // userName: row.userName,
              // agentName: row.agentName,
              name: studio.userName,
              ip: studio.clientIp,
              dcode: ''
            }
          })
        }
        const agentArr = agent.map(row => {
          return {
            id: row.id,
            model: 2,
            dctPrice: agentRenewOption.sellPrice,
            origPrice: agentRenewOption.marketPrice,
            orderMonth: agentRenewOption.value,
            expireDate: this.getExpireDate(row.expireDate, agentRenewOption.value),
            count: 1,
            instanceNo: row.agentNo,
            type: 2,
            license: {
              no: row.agentNo,
              alias: row.agentAlias,
              expireDate: row.expireDate
            },
            bind: {
              // userName: row.userName,
              // agentName: row.agentName,
              name: row.userName && row.agentName ? `${row.userName}@${row.agentName}` : '-',
              ip: row.agentIp,
              dcode: row.agentDcode
            }
          }
        })
        return [...studioArr, ...agentArr]
      })
    },
    getPriceList () {
      return getPriceList().then(({ agentNewList, agentRenewList, studioNewList, studioRenewList }) => {
        this.agentNewOptions = getOptions(agentNewList)
        this.agentRenewOptions = getOptions(agentRenewList)
        this.studioNewOptions = getOptions(studioNewList)
        this.studioRenewOptions = getOptions(studioRenewList)
      })
    },
    /**
     * 判断产品是否是单台设备
     */
    jumpProduct (e) {
      console.log(e.target.value)
      // if (this.paymentMethod === 3) {
      //   if (this.orderList.length === 1 && this.orderList[0].count === 1) return
      //   this.$message.error('兑换卡支付只能购单台设备')
      //   this.paymentMethod = 0
      // }
    },
    // 代理商推荐码
    onApcChange (e) {
      // console.log(e.target.checked)
      this.apcChecked = e.target.checked
      this.apcInfo.showProCodeInput = e.target.checked
      this.$set(this.apcInfo, 'proCode', '')
      // 显示优惠价，推荐码选中框、输入框可使用
      this.apcInfo.showPrice = false
      // 隐藏错误提示语
      this.$set(this.apcInfo, 'showErrTip', false)
      // 恢复为推广之前的实际价格
      this.shoppingCart.dctPrice = this.undiscountedPrice
      this.apcInfo.price = this.shoppingCart.dctPrice
    },
    // 校验推荐码
    proCodeChange (e) {
      // console.log(this.apcInfo)
      // 每次调整推荐码的时候，都隐藏推广价的显示
      this.apcInfo.showPrice = false
      // 恢复为推广之前的实际价格
      this.apcInfo.price = this.shoppingCart.dctPrice
      const { value } = e.target
      // console.log(value)
      const reg = /^[0-9]+$/
      if (((reg.test(value)) && value.length <= 6) || value === '') {
        this.apcInfo.proCode = value
      }
    },
    // 应用推荐码
    useProCode (callback = () => {}) {
      // 判断是否填写了推荐码
      if (!this.apcInfo.proCode) {
        this.$message.warning(this.$t('private.purchase.step1.popUps[7]'))
        return
      }
      // 通过推荐码获取折扣，并计算推广价
      getProCodeDisc(this.apcInfo.proCode).then(res => {
        // console.log(res)
        // 隐藏错误提示语
        this.$set(this.apcInfo, 'showErrTip', false)
        // 计算优惠价
        this.apcInfo.price = res ? Number(res[0].discount) * this.shoppingCart.dctPrice / 10 : this.shoppingCart.dctPrice
        // console.log('-----优惠价：', this.apcInfo.price)
        this.shoppingCart.dctPrice = this.apcInfo.price
        // 显示优惠价，禁用推荐码选中框、输入框
        this.apcInfo.showPrice = true
        // // 隐藏推荐码选中框、输入框
        // this.useProCodeFailed = false
        setTimeout(() => {
          callback()
        }, 100)
      }).catch(() => {
        // 显示错误提示语
        this.$set(this.apcInfo, 'showErrTip', true)
        this.apcInfo.proCode = ''
      })
    }
  }
}
</script>

<style lang="less" scoped>
@apc_color: #F8B551;
.my-modal{
  .list{
    max-height: 430px;
    overflow-y: auto;
  }
}
.purchase {
  background-color: #fff;
  padding: 0 24px;
  height: 100%;
  .steps{
    padding: 64px 284px;
  }
  .order-step, .write-step{
    .operations{
      text-align: right;
      padding: 24px;
      p{
        line-height: 28px;
      }
      button{
        margin-top: 24px;
      }
      .discount{
        font-size: 14px;
        color: #333333;
        text-decoration: line-through;
      }
      .payable{
        font-size: 14px;
        color: #262626;
        font-weight: bold;
        strong{
          font-size: 30px;
          color: #FF4032;
        }
      }
      .invoice{
        font-size: 16px;
        color: #666666;
      }
      .license{
        font-size: 14px;
        color: #262626;
        font-weight: bold;
      }
      .protocol{
        .ant-checkbox-wrapper{
          font-size: 14px;
          color: #333333;
        }
        a{
          color: #4977FC;
          text-decoration: underline;
        }
      }
    }
  }
  .write-step{
    // 合作码
    .recommendation {
      position: relative;
      .rec-code {
        // position: absolute;
        .apc-price {
          padding-top: 15px;
          text-align: center;
          color: #E4281A;
          font-size: 30px;
          font-weight: bold;
          >span {
            font-size: 16px;
            font-weight: normal;
          }
        }
        .apc-box {
          text-align: right;
          button {
            margin-top: 0;
          }
          .ant-btn[disabled] {
            color: rgba(0, 0, 0, 0.25);
            background-color: #f5f5f5;
            border-color: #d9d9d9;
          }
          .apc-err-tip {
            font-size: 14px;
            color: #E4281A;
            padding-bottom: 12px;
          }
          .ant-checkbox-wrapper {
            padding-bottom: 24px;
            font-size: 16px;
            color: #666;
            &:hover /deep/.ant-checkbox-inner {
              border-color: @apc_color;
            }
            /deep/.ant-checkbox {
              // font-size: 16px;
              .ant-checkbox-inner {
                height: 18px;
                width: 18px;
                &::after {
                  left: 4.571429px;
                  top: 2.142857px;
                }
              }
              &:hover .ant-checkbox-inner,
              .ant-checkbox-input:focus + .ant-checkbox-inner {
                border-color: @apc_color;
              }
              &.ant-checkbox-checked {
                .ant-checkbox-inner {
                  background-color: @apc_color;
                  border-color: @apc_color;
                }
              }
            }
          }
          .apc-con {
            padding-bottom: 24px;
            input {
              width: 248px;
              color: #666;
              font-size: 16px;
              margin-right: 10px;
            }
            button {
              color: #fff;
              background-color: @apc_color;
              border-color: @apc_color;
              line-height: 1.3;
              vertical-align: 2px;
            }
          }
        }
      }
    }
    .list{
      .cover{
        width: 80px;
        height: 52px;
      }
      .license{
        line-height: 24px;
        .no{
          color: #999999;
        }
        .alias{
          color: #666666;
        }
        .expire-date{
          color: #CCC;
        }
      }
      .bind{
        color: #999999;
        line-height: 24px;
        .name{
          color: #666666;
        }
        .ip{

        }
        .dcode{

        }
      }
      .count{
        color: #999999;
      }
      .price{
        color: #666;
      }
      .operation{
        span{
          color: #1890ff;
          cursor: pointer;
          transition: color 0.3s;
          /*position: relative;*/
          &:hover{
            color: #40a9ff;
          }
          & + span{
            &:before{
              content: '';
              display: inline-block;
              height: 12px;
              width: 1px;
              background-color: #e8e8e8;
              margin: 0 8px -1px;
            }
          }
        }
      }
    }
  }
  .order-step{
    .list{
      .info{
        font-size: 14px;
        color: #666;
        line-height: 28px;
        strong{
          font-size: 16px;
          color: #262626;
          font-weight: normal;
        }
      }
    }
    .payment-method{
      margin-top: 24px;
      h3{
        background:rgba(250,250,250,1);
        box-shadow:0px 1px 0px 0px rgba(238,238,238,1);
        line-height: 48px;
        font-size: 18px;
        font-weight: bold;
        color: #000;
        padding: 0 24px;
      }
      /deep/ .methods{
        box-shadow:0px 1px 0px 0px rgba(238,238,238,1);
        padding: 24px 24px 44px;
        display: block;
        .ant-radio{
          vertical-align: middle;
        }
        .ant-radio-wrapper{
          border: 1px solid #E8E8E8;
          padding: 4px 10px;
          margin-right: 24px;
        }
      }
    }
  }
  .pay-step{
    .operations{
      text-align: right;
      padding: 24px;
    }
  }
  .finish-step{
    text-align: center;
    line-height: 1;
    .iconwanchengrenwu{
      font-size: 72px;
      color: #52C41A;
    }
    .iconrenwushibai{
      font-size: 72px;
      color: #f5222d;
    }
    .pay-ok{
      font-size: 24px;
      color: #262626;
      line-height: 48px;
      margin-top: 24px;
    }
    .pay-info{
      font-size: 14px;
      color: #5C5C5C;
      line-height: 48px;
    }
    .operations{
      margin-top: 108px;
      margin-bottom: 64px;
    }
  }
}
</style>
